import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react-lite';
import styles from './content-editor.module.scss';
import {EditorSection} from './EditorSection/EditorSection';
// import {FocusTermsPopups} from './FocusTermsPopups';
import {TopSection} from './TopSection/TopSection';
import styled from 'styled-components';
import {TextSuggestions} from '../RightSidebar/v2-sidebar/Analytics/TermsAssistant/TextSuggestions';
import {TextSuggestionsLinks} from '../RightSidebar/v2-sidebar/Analytics/LinkAssistant/TextSuggestionsLinks';


interface Props {
  // allRef: any;
  newPage: any;
  htmlToDraft: any;
}

export const LeftSide = observer(({newPage, htmlToDraft}: Props) => {
  const {contentOptimizer} = useStore('');
  const {currentPage} = contentOptimizer;
  const {
    sideBarWidth,
    isSideBarHidden,
    isTaActive,
    isLinkActive,
  } = currentPage;

  return <LeftSideContainer isLinkSuggestionActive={currentPage?.isLinkActive} isNewPage={currentPage.newPage} isSideBarHidden={isSideBarHidden} sideBarWidth={sideBarWidth}>
    <div style={isTaActive || isLinkActive ? {height: 0, overflow: 'hidden'} : {}}>
      <TopSection
        // do not remove yet
        // allRef={allRef}
        newPage={newPage} />
      {!isTaActive || isLinkActive ? <div className={styles.divider}></div> : null}

      <EditorSection htmlToDraft={htmlToDraft} />
    </div>

    {(isTaActive && <TextSuggestions />) || (isLinkActive && <TextSuggestionsLinks />)}
  </LeftSideContainer>;
});


const LeftSideContainer = styled.div<{isNewPage?: boolean; isSideBarHidden?: boolean; sideBarWidth?: string; isLinkSuggestionActive?: boolean}>`
  overflow: hidden;
  text-align: -webkit-center; 
  transition: all .3s ease;
  width: 100%;
  max-width: ${p => p.isLinkSuggestionActive ? '100%' : !p.isNewPage ? !p.isSideBarHidden ? `calc(100% - ${p.sideBarWidth} + 15px)` : '100%' : '100%'};
`;
